import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(_component_q_chip, {
    class: _normalizeClass({
            'non-interactive': _ctx.nonInteractive,
            'uncut-label': _ctx.uncutLabel,
            'q-chip-lg': _ctx.size === 'lg',
            'q-chip-md': _ctx.size === 'md',
            'q-chip-sm': _ctx.size === 'sm'
        }),
    style: _normalizeStyle({
            'background-color': _ctx.backgroundColor ? `var(--q-${_ctx.backgroundColor}) !important` : undefined,
            'border-color': _ctx.borderColor ? `var(--q-${_ctx.borderColor}) !important` : undefined
        }),
    ripple: !_ctx.nonInteractive,
    "icon-remove": _ctx.ICONS_NAME.TIMES_CIRCLE_SOLID,
    removable: _ctx.removable,
    onRemove: _ctx.remove
  }, {
    default: _withCtx(() => [
      (_ctx.color)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "rectangle",
            style: _normalizeStyle({ 'background-color': `var(--q-${_ctx.color})` })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.point)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "point",
            style: _normalizeStyle({ color: `var(--q-${_ctx.point})` })
          }, " • ", 4))
        : _createCommentVNode("", true),
      (_ctx.icon && !_ctx.iconRight)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 2,
            color: _ctx.iconColor,
            name: _ctx.icon
          }, null, 8, ["color", "name"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "avatar", {}, undefined, true),
      (_ctx.label || _ctx.labelSlot)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(["ellipsis", _ctx.icon !== null ? 'q-pr-xs' : ''])
          }, [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ], true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.icon && _ctx.iconRight)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 4,
            class: "q-ml-xs",
            color: _ctx.iconColor,
            name: _ctx.icon
          }, null, 8, ["color", "name"]))
        : _createCommentVNode("", true),
      ((_ctx.tooltip && _ctx.label) || _ctx.tooltipLabel)
        ? (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 5 }, _ctx.TOOLTIP_PROPS)), {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.tooltipLabel || _ctx.label), 1)
            ]),
            _: 1
          }, 16))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "style", "ripple", "icon-remove", "removable", "onRemove"]))
}